var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExplore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1128 -195) translate(355 182) translate(30) translate(633 7) translate(100) translate(10 6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "nonzero",
    d: "M14.14.26S10.741-.283 6.917 3.54C4.603 5.854 2.69 9.207 2.69 9.207l2.502 2.502s3.353-1.912 5.666-4.226C14.683 3.66 14.14.26 14.14.26zM9.537 6.185c-.362.351-.94.345-1.295-.013-.355-.36-.355-.937 0-1.296.355-.358.933-.364 1.295-.013.179.173.28.412.28.66 0 .25-.101.489-.28.662zm2.29-2.29c-.363.351-.94.345-1.295-.013-.355-.359-.355-.937 0-1.296.355-.358.932-.364 1.295-.013.357.36.357.94 0 1.298v.024zM5.69 12.535l-.638.354-.095-.094-.354 1.605c1.086-.379 2.111-.911 3.046-1.582 1.18-.826 1.345-1.558 1.274-2.455-1.037.783-2.117 1.508-3.234 2.172zM4.06 5.453c-.92-.07-1.652.095-2.478 1.275C.91 7.67.377 8.703 0 9.797l1.605-.354-.094-.095.378-.614c.662-1.133 1.387-2.228 2.171-3.28z",
    transform: "translate(4.8 4.8)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExplore);
export default __webpack_public_path__ + "static/media/icon-explore.69cb3e158dced8c8d17231d202a50975.svg";
export { ForwardRef as ReactComponent };